import React from "react";
import MuiIconDoubleArrow from "@mui/icons-material/DoubleArrow";
import MuiIconLogList from "@mui/icons-material/FormatListBulleted";
import MuiIconUserList from "@mui/icons-material/RecentActors";

// Source
import * as HelperSrc from "../HelperSrc";
import ControllerSidebar from "../controller/Sidebar";
import ControllerLocalization from "../controller/Localization";
import * as ModelSidebar from "../model/Sidebar";
import * as CustomSidebar from "./custom/Sidebar";

let isRendered = false;

const viewSidebar: React.FC<ModelSidebar.Iprops> = (props) => {
    // Variable
    const controllerSidebar = new ControllerSidebar(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerSidebar.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="view_sidebar" data-at_id="view_sidebar">
                <div>
                    <CustomSidebar.viewMenuData />
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (HelperSrc.checkRole(controllerSidebar.getStorageRole, ["superuser", "support"], props.userData)) {
                            html.push(
                                <div className="admin">
                                    <p className="text">
                                        <span className="label">- {controllerLocalization.getStorageMain.master_data}</span>
                                    </p>
                                    <div
                                        className="icon_text"
                                        data-at_id="sidebar_user_list"
                                        onClick={() => {
                                            if (controllerSidebar.getStorageRoute) {
                                                HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.user_list.path);
                                            }
                                        }}
                                    >
                                        <MuiIconUserList />
                                        <p>{controllerLocalization.getStorageMain.user}</p>
                                        <p>{controllerLocalization.getStorageMain.list}</p>
                                        <div className="description">{`${controllerLocalization.getStorageMain.user} - ${controllerLocalization.getStorageMain.list}`}</div>
                                    </div>
                                    <div
                                        className="icon_text"
                                        data-at_id="sidebar_log_list"
                                        onClick={() => {
                                            if (controllerSidebar.getStorageRoute) {
                                                HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.log_list.path);
                                            }
                                        }}
                                    >
                                        <MuiIconLogList />
                                        <p>{controllerLocalization.getStorageMain.system_log}</p>
                                        <p>{controllerLocalization.getStorageMain.list}</p>
                                        <div className="description">{`${controllerLocalization.getStorageMain.system_log} - ${controllerLocalization.getStorageMain.list}`}</div>
                                    </div>
                                    <CustomSidebar.viewMasterData />
                                </div>
                            );
                        }

                        return html;
                    })()}
                    <MuiIconDoubleArrow
                        className="arrow"
                        onClick={() => {
                            controllerSidebar.clickArrow();
                        }}
                    />
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export default viewSidebar;
